import { ContainerContextValueType, HomePageEditorProviderProps, Item } from '@src/lib/types/home-page-editor';
import { useInputHelper } from '@src/utils/inputs-helper';
import _ from 'lodash';
import React, { createContext, useContext } from 'react';
import { useRafflePageEditorContext } from '../provider';

const initialState: Item = {
  "description": "",
  "image": "",
} as Item

export const CreateContext = createContext<ContainerContextValueType>({} as ContainerContextValueType);

const CreateProvider = ({ children }: HomePageEditorProviderProps) => {
  const [error, setError ] = React.useState({});
  const { state, onSetInitial, onDispatch, handleFormReset } = useInputHelper(initialState);
  const { container, state: STATE, setContainer, onDispatch: ONDISPATCH } = useRafflePageEditorContext();

  const onSubmit = React.useCallback(() => {
    const Err: any = {};
    if(!state.description){
      Err.description = true
    }

    setError(Err);

    if(_.isEmpty(Err)){
      ONDISPATCH(container)(state.description);
      setContainer("");
    }
  }, [state, ONDISPATCH, container, setContainer]);

  const value = {
    state,
    error,
    onDispatch,
    onSubmit
  };

  React.useEffect(() => {
    if(!_.isEmpty(error)){
      setError({});
    }
  },[state, error]);

  React.useEffect(() => {
    if(container){
      const item = STATE[container];
      onSetInitial({description: item});
    }

    return () => {
      handleFormReset();
    }
  },[container, STATE, handleFormReset, onSetInitial]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <CreateContext.Provider value={value}>
      {children}
    </CreateContext.Provider>
  );
};

export const useCreateContext = () => {
  return useContext(CreateContext);
}

export default CreateProvider;
